import cookies from '@utils/cookies'

export const state = {
  invoice: {
    id: null,
    hash: null,
  },
}

export const getters = {
  getField,
}

export const mutations = {
  updateField,

  SET_INVOICE(state, { id, hash }) {
    state.invoice = { id, hash }
  },
}

export const actions = {
  prepareInvoicePayload({ rootState, rootGetters }, { extra = {} } = {}) {
    const { clientId, signature, data } = rootState['payment'].paymentCredentials
    const { email, qiwiWallet, phone } = rootState['payer']

    const payload = {
      client_id: clientId,
      signature,
      data,
      email,
    }

    const { paymentMethod, paymentRegion } = rootState['payment']

    if (['fakeMobile', 'fakeMobileDobro', 'qiwiMyCom', 'qiwiDobro', 'sberPay', 'sberPaySmgl'].includes(paymentMethod)) {
      payload.phone = ['qiwiMyCom', 'qiwiDobro'].includes(paymentMethod) ? qiwiWallet : phone
    }

    payload.system = paymentMethod

    if (['adyenSofortEur', 'trustly'].includes(paymentMethod)) {
      payload.country = paymentRegion
    }

    if (extra && extra.paymentToken) {
      _.set(payload, 'extra.payment_token', extra.paymentToken)
    }

    return payload
  },

  async createInvoice({ commit, state, dispatch, rootGetters, rootState }, extra) {
    commit('payer/SAVE_PAYER_INFO', null, { root: true })
    commit('payment/SAVE_PAYMENT_SETTINGS', null, { root: true })

    const payload = await dispatch('prepareInvoicePayload', { extra })

    console.log('createInvoice', payload)

    return api.post('/payin/pwinvoice', payload)
      .then(({ data }) => {
        commit('SET_INVOICE', { id: data.invoice_id, hash: data.hash })

        const { action, redirect_url, text } = data

        return { invoice: state.invoice, action, redirect_url, text }
      })
  },

  checkInvoice({ state, rootState }) {
    const { id, hash } = state.invoice
    const { type } = rootState['payment'].paymentData

    return api
      .get('/payin/invoice', {
        type,
        id,
        hash,
      })
      .then(({ data }) => data)
  },
}
